import { render, staticRenderFns } from "./DetailWrapper.vue?vue&type=template&id=ec8cb49a&"
import script from "./DetailWrapper.vue?vue&type=script&lang=js&"
export * from "./DetailWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports